import React, { useCallback, useEffect, useState } from "react";
import { MODULE_API } from "../../../../apis";
import * as Style from "../../../modules/assests_new/asset-listing/styles/Asset-Listing";
import tableimg from "../../../../assets/images/big/camera.png";
import percentIcon from "../../../../assets/SVGs/percent.svg";
import accountIcon from "../../../../assets/SVGs/account-balance.svg";
import dollarIcon from "../../../../assets/SVGs/dollar-bag-hand.svg";
import { Modal, Button } from "antd";
import swal from "sweetalert";
import { Link, useHistory } from "react-router-dom";
import addIcon1 from "../../../../assets/images/DeathModuleNew/addIcon.png";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import NewLoader from "../../../../components/styled-components/loader/NewLoader";
import moment from "moment";
function LiabilityListing(props) {
  const [allProperties, setAllProperties] = useState([]);
  const [activeItem, setActiveItem] = useState("");
  const [activeRoom, setActiveRoom] = useState();
  const [allItems, setAllItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isModal, setModal] = useState(false);
  const [showItems, setShowItems] = useState(false);
  const [showItemAdd, setShowItemAdd] = useState(false);
  const history = useHistory();

  const updateInventory = useCallback((item) => {}, []);
  const updateProperties = useCallback(() => {
    liabilityReport();
  }, []);

  const { module } = useParams();

  useEffect(() => {
    liabilityReport();
  }, []);
  let propertiesList = [];

  async function liabilityReport() {
    try {
      setIsLoading(true);
      setAllProperties([]);
      let airplane = await MODULE_API.fetchItems({
        moduleName: module,
        pageNum: 1,
        limit: 10,
        body: {},
      });
      setIsLoading(false);
      console.log("new report");

      // propertiesList=airplane&&
      propertiesList =
        airplane &&
        airplane.records.map((properties) => ({
          id: properties.id,
          Owner: properties.Owner,
          module: properties.module,
          type: properties.type ? properties.type : 0,
          subType: properties.subType ? properties.subType : 0,
          img: properties.image ? properties.image : tableimg,
          name: properties.NameofAsset,
          total: properties.total ? properties.total : 0,
          "Account Type/Titled": properties["Account Type/Titled"],
          loanType: properties["Type of Loan"],
          loanAmount: properties["Initial Loan Amount"],
          nickName:
            properties["Nickname of Liabilities"] ||
            properties["Nickname of Credit"],
          interestRate: properties["Interest Rate"]
            ? properties["Interest Rate"]
            : properties["Interest Rate (or APR%)"]
            ? properties["Interest Rate (or APR%)"]
            : null,
          maturityDate: properties["Maturity Date"]
            ? properties["Maturity Date"]
            : null,
          monthlyPayment: properties["Monthly Payment"]
            ? properties["Monthly Payment"]
            : null,
          loanBalance: properties["Loan Balance"]
            ? properties["Loan Balance"]
            : properties["Credit Balance"]
            ? properties["Credit Balance"]
            : null,
          accountNumber: properties["Account Number"]
            ? properties["Account Number"]
            : null,
        }));
      setAllProperties(propertiesList);
      // dispatch(saveAllProperties(propertiesList));
    } catch (error) {
      console.log("e ", error);
    }
  }

  function handleDelete(event, item, type) {
    console.log(
      "event",
      event,
      "item",
      item,
      "active Item=>",
      activeItem,
      activeRoom
    );
    swal({
      title: "Are you sure?",
      text: "Are you sure that you want to Delete this?",
      icon: "warning",
      dangerMode: true,
      buttons: true,
    }).then(async (doDelete) => {
      setIsLoading(true);
      doDelete &&
        (await MODULE_API.removeClientModule({
          clientModules: [item.id],
        }));
      if (type == "property") {
        updateProperties();
        setActiveItem("");
        return;
      } else if (type == "room") {
        await MODULE_API.getRecordTotal(activeItem.id, {
          attributes: ["total"],
        });
        setAllItems("");
        setShowItems(false);
        setShowItemAdd(false);
      } else {
        await MODULE_API.getRecordTotal(activeRoom, {
          attributes: ["currentValue"],
        });
        await MODULE_API.getRecordTotal(activeItem.id, {
          attributes: ["total"],
        });
      }
      updateInventory(activeItem);
    });
  }

  function deletePost(id) {
    console.log("delete is", id);
    swal({
      title: "Are you sure?",
      text: "You want to delete this?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (result) => {
      if (result === true) {
        setIsLoading(true);

        try {
          const res = await MODULE_API.removeClientModule({
            clientModules: [id],
          });
          liabilityReport();
          setIsLoading(false);
        } catch (error) {
          setIsLoading(false);
        }
      }
    });
  }
  function handleEdit(event, item, type) {
    history.push(
      `/liabilities_credit_new/attributes/${item.module}/${item.id}`
    );
  }

  function moneyFormatter(value) {
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    });

    let result = formatter.format(value);
    console.log("Money :: ", result);
    return result;
  }

  function handleViewitem(event, item, type) {
    history.push(
      `/liabilities_credit_new/attributes/${item.module}/${item.id}/view`
    );
  }
  return (
    <div style={{ position: "relative" }}>
      <Style.Main>
        <Style.Cards
          style={{
            borderBottom:
              allProperties && allProperties.length > 0
                ? "1px solid #F0F0F0"
                : "none",
          }}
        >
          <Style.SubCards
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Style.CardsHead>
              <h3
                style={{
                  fontWeight: "bold",
                  fontFamily: "Poppins",
                  fontSize: "20px",
                }}
              >
                {module === "Real Estates" ? "Real Estate" : module}
              </h3>
            </Style.CardsHead>
            <Style.PropertyAdd
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div style={{ marginRight: "1rem" }}>
                <h3 style={{ fontFamily: "Poppins", fontSize: "20px" }}>
                  Add {module === "Real Estates" ? "Real Estate" : module}
                </h3>
              </div>

              <Link
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                to={`/liabilities_credit_new/attributes/${module}`}
              >
                <div
                  className="upload"
                  style={{ width: "28px", height: "28px" }}
                >
                  <img
                    src={addIcon1}
                    width={12}
                    height={12}
                    style={{ width: "16px", height: "16px" }}
                    alt="addicon"
                  ></img>
                </div>
                {/*<Style.AddBtn>
                  <img src={addIcon} />
                 
                </Style.AddBtn> */}
              </Link>
            </Style.PropertyAdd>
          </Style.SubCards>
          <Style.CardsMain
            style={{
              justifyContent:
                allProperties && allProperties.length > 0 ? "start" : "center",
              grid: allProperties && allProperties.length === 0 && "initial",
              padding: "8px",
              gap: "1rem",
            }}
          >
            {/* {allProperties? allProperties.length >0: <p>No record found.</p>} */}
            {allProperties && allProperties.length > 0 ? (
              allProperties.map((item, index) => (
                <Style.Card
                  key={index}
                  active={item.id == activeItem}
                  style={{ padding: "0", overflow: "hidden" }}
                >
                  {/* Image Section */}
                  <div
                    style={{
                      padding: "1.5rem 1rem 0.5rem",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      height: "220px",
                      alignItems: "center",
                    }}
                  >
                    <Style.Img
                      src={item.img}
                      style={{
                        width: "auto",
                        height: "100%",
                        maxHeight: "200px",
                        maxWidth: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>

                  {/* Header: Title and Actions */}
                  <Style.CardHeader>
                    <Style.CardTitle>
                      {item.nickName ? item.nickName : "N/A"}
                    </Style.CardTitle>
                    <Style.CardIcons>
                      <Button
                        type="link"
                        icon="edit"
                        style={{ color: "black", fontSize: "18px" }}
                        onClick={(e) => {
                          handleEdit(e, item, "property");
                        }}
                      />
                      <Button
                        type="link"
                        icon="eye"
                        style={{ color: "black", fontSize: "18px" }}
                        onClick={(e) => {
                          handleViewitem(e, item, "property");
                        }}
                      />
                      <Button
                        type="link"
                        icon="delete"
                        style={{ color: "black", fontSize: "18px" }}
                        onClick={(e) => {
                          handleDelete(e, item, "property");
                          deletePost(item.id);
                        }}
                      />
                    </Style.CardIcons>
                  </Style.CardHeader>

                  {/* Main Value Section */}
                  <Style.CardValueSection>
                    <Style.CardValue>
                      {item.loanBalance
                        ? moneyFormatter(item.loanBalance)
                        : "$0.00"}
                    </Style.CardValue>
                    <Style.CardLabel>Balance</Style.CardLabel>
                  </Style.CardValueSection>

                  {/* Footer Stats */}
                  <Style.StatsContainer>
                    <Style.StatBox>
                      <div style={{ fontSize: "1.2rem" }}>
                        <img src={percentIcon} width={32} alt="percent" />
                      </div>
                      <Style.StatLabel>Interest Rate</Style.StatLabel>
                      <Style.StatValue>
                        {item.interestRate
                          ? parseFloat(item.interestRate).toFixed(2) + "%"
                          : "N/A"}
                      </Style.StatValue>
                    </Style.StatBox>

                    <Style.StatBox>
                      <div style={{ fontSize: "1.2rem" }}>
                        <img src={dollarIcon} width={32} alt="payment" />
                      </div>
                      <Style.StatLabel>Monthly Payment</Style.StatLabel>
                      <Style.StatValue>
                        {item.monthlyPayment
                          ? moneyFormatter(item.monthlyPayment)
                          : "N/A"}
                      </Style.StatValue>
                    </Style.StatBox>

                    <Style.StatBox last>
                      <div style={{ fontSize: "1.2rem" }}>
                        <img src={accountIcon} width={32} alt="account" />
                      </div>
                      <Style.StatLabel>Account Number</Style.StatLabel>
                      <Style.StatValue>
                        {item.accountNumber
                          ? "****" + item.accountNumber
                          : "N/A"}
                      </Style.StatValue>
                    </Style.StatBox>
                  </Style.StatsContainer>
                </Style.Card>
              ))
            ) : (
              <h1
                style={{
                  marginTop: "6rem",
                  width: "max-content",
                  textAlign: "center",
                }}
              >
                No data to show
              </h1>
            )}
          </Style.CardsMain>
        </Style.Cards>
      </Style.Main>
      <div>
        <Modal
          width={"58rem"}
          visible={isModal}
          footer={null}
          // onCancel={handleModalCancel}
          // style={{ width: showUpdateItem && "fit-content" }}
          bodyStyle={{
            overflowY: "auto",
            maxHeight: "calc(100vh - 200px)",
          }}
        ></Modal>
      </div>
      <NewLoader isLoading={isLoading} />
    </div>
  );
}

export default LiabilityListing;
